import {needAuth} from "../instance/Instance";

async function selectMaintenanceList(id, contentCategory) {
    console.log(">> 유지보수 자산 조회")
    const search = {entityIds : [id], maintenanceEnum : contentCategory};

    try{
        return  await needAuth.post(`/maintenanceAsset`, search);
    }catch (error){
        return error;
    }
}

async function selectMaintenanceListByAsset(search, pageable) {
    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {

            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post(`/maintenanceAsset/tab-list?`+pageStr,search);
    }catch (error){
        return error;
    }
}

async function createMaintenanceAssets(id, asset, contentCategory) {
    const maintenance ={entityId : id , asset : {id : asset}, entityName : contentCategory}
    return await needAuth.post(`/maintenanceAsset/create`, maintenance);
}

async function removeMaintenanceAssets(id, asset, contentCategory) {
    return await needAuth.delete(`/maintenanceAsset/delete?entityId=`+id+`&asset=`+asset+`&entityName=`+contentCategory);
}

export {selectMaintenanceList, createMaintenanceAssets, removeMaintenanceAssets, selectMaintenanceListByAsset}